var getPartsOfValue = function getPartsOfValue(value) {
  return value.trim().split(/\s+/);
};
var getInlineValue = function getInlineValue(value) {
  var parts = getPartsOfValue(value);
  if (parts.length === 1) {
    return {
      baseValue: value
    };
  }
  return {
    startValue: parts[0],
    endValue: parts[1]
  };
};
var getFourDimensionalValue = function getFourDimensionalValue(value) {
  var parts = getPartsOfValue(value);
  if (parts.length === 1) {
    return {
      blockStartValue: parts[0],
      blockEndValue: parts[0],
      inlineStartValue: parts[0],
      inlineEndValue: parts[0]
    };
  }
  if (parts.length === 2) {
    return {
      blockStartValue: parts[0],
      blockEndValue: parts[0],
      inlineStartValue: parts[1],
      inlineEndValue: parts[1]
    };
  }
  if (parts.length === 3) {
    return {
      blockStartValue: parts[0],
      blockEndValue: parts[2],
      inlineStartValue: parts[1],
      inlineEndValue: parts[1]
    };
  }
  return {
    blockStartValue: parts[0],
    blockEndValue: parts[2],
    inlineStartValue: parts[3],
    inlineEndValue: parts[1]
  };
};

export { getFourDimensionalValue, getInlineValue, getPartsOfValue };
